/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { ReactComponent as ImageCardStyleHorizontal } from "assets/images/icons/components/image-card-style-horizontal.svg";
import { ReactComponent as ImageCardStyleHorizontalSelected } from "assets/images/icons/components/image-card-style-horizontal-selected.svg";
import { ReactComponent as ImageCardStyleVertical } from "assets/images/icons/components/image-card-style-vertical.svg";
import { ReactComponent as ImageCardStyleVerticalSelected } from "assets/images/icons/components/image-card-style-vertical-selected.svg";

const ImageCardTypeButtons = (props) => {
    
    const {
        imageCard,
        onChange,
    } = props || {};
    
    const { t } = useTranslation();
    const isHorizontal = imageCard === "horizontal";
    const isVertical = imageCard === "vertical";
    const DIRECTION = {
        HORIZONTAL: "horizontal",
        VERTICAL: "vertical"
    };
    
    return (
        <div className='image-card-type-container'>
            <Tooltip
                title={t("commons.sideBySide")}
                placement='top'
                arrow
                classes={{ arrow: "arrow", tooltip: "tooltip" }}
            >
                <div className='type' onClick={() => onChange(DIRECTION.HORIZONTAL)}>
                    {isHorizontal &&
                        <ImageCardStyleHorizontalSelected />
                    }
                    {!isHorizontal &&
                        <ImageCardStyleHorizontal />
                    }
                </div>
            </Tooltip>
            <Tooltip
                title={t("commons.stacked")}
                placement='top'
                arrow
                classes={{ arrow: "arrow", tooltip: "tooltip" }}
            >
                <div
                    className='type'
                    onClick={() => onChange(DIRECTION.VERTICAL)}
                >
                    {isVertical &&
                        <ImageCardStyleVerticalSelected />
                    }
                    {!isVertical &&
                        <ImageCardStyleVertical />
                    }
                </div>
            </Tooltip>
        </div>
    );
};

ImageCardTypeButtons.displayName = "ImageCardTypeButtons";
export { ImageCardTypeButtons };
